export enum OrderStatus {
  AwaitingAvailability = 0,
  AwaitingShippingInfo = 1,
  AwaitingPayment = 3,
  ProcessingPayment = 4,
  Paid = 5,
  Shipped = 6,
  Cancelled = 7
};
